import React, { FC } from "react";
import { useTranslation } from "react-i18next";

import "./style.scss";

const IsNotPriceAvailableMessage: FC = () => {
  const { t } = useTranslation("productDetails");
  return (
    <div className="item_info">
      <span className="not_available">{t("notAvailableIn")}</span>
    </div>
  );
};

export default IsNotPriceAvailableMessage;
